import { PhrasesSelectorPhrase, PhrasesSelectorWizardId } from '../../typings/phrases';

interface PhrasesSelectorRefinementsBaseAction {
    wizardId: PhrasesSelectorWizardId;
}

export const PHRASES_SELECTOR_GET_REFINE_WORDS = 'PHRASES_SELECTOR_GET_REFINE_WORDS';
export type PHRASES_SELECTOR_GET_REFINE_WORDS = typeof PHRASES_SELECTOR_GET_REFINE_WORDS;

export interface PhrasesSelectorGetRefineWordsAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_GET_REFINE_WORDS;
    phrase: string;
}

export function phrasesSelectorGetRefineWords(
    wizardId: PhrasesSelectorWizardId,
    phrase: string
): PhrasesSelectorGetRefineWordsAction {
    return {
        type: PHRASES_SELECTOR_GET_REFINE_WORDS,
        wizardId,
        phrase
    };
}

export const PHRASES_SELECTOR_SET_REFINE_WORDS = 'PHRASES_SELECTOR_SET_REFINE_WORDS';
export type PHRASES_SELECTOR_SET_REFINE_WORDS = typeof PHRASES_SELECTOR_SET_REFINE_WORDS;

export interface PhrasesSelectorSetRefineWordsAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_SET_REFINE_WORDS;
    words: Array<PhrasesSelectorPhrase>;
    hasMore: boolean;
}

export function phrasesSelectorSetRefineWords(
    wizardId: PhrasesSelectorWizardId,
    words: Array<PhrasesSelectorPhrase>,
    hasMore: boolean
): PhrasesSelectorSetRefineWordsAction {
    return {
        type: PHRASES_SELECTOR_SET_REFINE_WORDS,
        wizardId,
        words,
        hasMore
    };
}

export const PHRASES_SELECTOR_GET_PHRASE_STATS = 'PHRASES_SELECTOR_GET_PHRASE_STATS';
export type PHRASES_SELECTOR_GET_PHRASE_STATS = typeof PHRASES_SELECTOR_GET_PHRASE_STATS;

export interface PhrasesSelectorGetPhraseStatsAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_GET_PHRASE_STATS;
    phrase: string;
}

export function phrasesSelectorGetPhraseStats(
    wizardId: PhrasesSelectorWizardId,
    phrase: string
): PhrasesSelectorGetPhraseStatsAction {
    return {
        type: PHRASES_SELECTOR_GET_PHRASE_STATS,
        wizardId,
        phrase
    };
}

export const PHRASES_SELECTOR_SET_PHRASE_STATS = 'PHRASES_SELECTOR_SET_PHRASE_STATS';
export type PHRASES_SELECTOR_SET_PHRASE_STATS = typeof PHRASES_SELECTOR_SET_PHRASE_STATS;

export interface PhrasesSelectorSetPhraseStatsAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_SET_PHRASE_STATS;
    shows: number;
}

export function phrasesSelectorSetPhraseStats(
    wizardId: PhrasesSelectorWizardId,
    shows: number
): PhrasesSelectorSetPhraseStatsAction {
    return {
        type: PHRASES_SELECTOR_SET_PHRASE_STATS,
        wizardId,
        shows
    };
}

export const PHRASES_SELECTOR_CHANGE_REFINE_PHRASE = 'PHRASES_SELECTOR_CHANGE_REFINE_PHRASE';
export type PHRASES_SELECTOR_CHANGE_REFINE_PHRASE = typeof PHRASES_SELECTOR_CHANGE_REFINE_PHRASE;

export interface PhrasesSelectorChangeRefinePhraseAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_CHANGE_REFINE_PHRASE;
    phrase: string;
}

export function phrasesSelectorChangeRefinePhrase(
    wizardId: PhrasesSelectorWizardId,
    phrase: string
): PhrasesSelectorChangeRefinePhraseAction {
    return {
        type: PHRASES_SELECTOR_CHANGE_REFINE_PHRASE,
        wizardId,
        phrase
    };
}

export const PHRASES_SELECTOR_SET_PHRASE_INFO = 'PHRASES_SELECTOR_SET_PHRASE_INFO';
export type PHRASES_SELECTOR_SET_PHRASE_INFO = typeof PHRASES_SELECTOR_SET_PHRASE_INFO;

export interface PhrasesSelectorSetPhraseInfoAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_SET_PHRASE_INFO;
    phrase: string;
    shows: number;
}

export function phrasesSelectorSetPhraseInfo(
    wizardId: PhrasesSelectorWizardId,
    phrase: string,
    shows: number
): PhrasesSelectorSetPhraseInfoAction {
    return {
        type: PHRASES_SELECTOR_SET_PHRASE_INFO,
        wizardId,
        phrase,
        shows
    };
}

export const PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR = 'PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR';
export type PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR = typeof PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR;

export interface PhrasesSelectorSetRefinePhrasesErrorAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR;
    message: string;
}

export function phrasesSelectorSetRefinePhrasesError(
    wizardId: PhrasesSelectorWizardId,
    message: string
): PhrasesSelectorSetRefinePhrasesErrorAction {
    return {
        type: PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR,
        wizardId,
        message
    };
}

export const PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR = 'PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR';
export type PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR = typeof PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR;

export interface PhrasesSelectorSetRefinePhraseShowsErrorAction extends PhrasesSelectorRefinementsBaseAction {
    type: PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR;
    message: string;
}

export function phrasesSelectorSetRefinePhraseShowsError(
    wizardId: PhrasesSelectorWizardId,
    message: string
): PhrasesSelectorSetRefinePhraseShowsErrorAction {
    return {
        type: PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR,
        wizardId,
        message
    };
}

export type PhrasesSelectorRefinementsAction =
    | PhrasesSelectorGetRefineWordsAction
    | PhrasesSelectorSetRefineWordsAction
    | PhrasesSelectorGetPhraseStatsAction
    | PhrasesSelectorSetPhraseStatsAction
    | PhrasesSelectorChangeRefinePhraseAction
    | PhrasesSelectorSetPhraseInfoAction
    | PhrasesSelectorSetRefinePhrasesErrorAction
    | PhrasesSelectorSetRefinePhraseShowsErrorAction;
